import React, { useEffect, useState } from 'react';
import { translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box, ThemeProvider, Typography, useTheme } from '@mui/material';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import SelectPaginate from 'app/shared/components/select-paginate/SelectPaginate';
import { BoxForm, FormControlDefault, TextFieldForms, TypographyForms } from 'app/shared/layout/register/DefaultFormsComponents';
import { RegisterButton } from 'app/shared/layout/register/RegisterButton';
import { RegisterLayout } from 'app/shared/layout/register/RegisterLayout';
import { RegisterTitle } from 'app/shared/layout/register/RegisterTitle';
import { createEntity, getEntity, reset, updateEntity } from './fifth-wheel.reducer';
import { toast } from 'react-toastify';

export const FifthWheelUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const fifthWheelEntity = useAppSelector(state => state.fifthWheel.entity);
  const loading = useAppSelector(state => state.fifthWheel.loading);
  const updating = useAppSelector(state => state.fifthWheel.updating);
  const updateSuccess = useAppSelector(state => state.fifthWheel.updateSuccess);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const [formData, setFormData] = useState({
    company: null,
    identificationCode: '',
    truckImplement: null,
  });

  const handleClose = () => {
    props.history.push('/fifth-wheel' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (!isNew && fifthWheelEntity) {
      setFormData({
        company: fifthWheelEntity.company,
        identificationCode: fifthWheelEntity.identificationCode,
        truckImplement: fifthWheelEntity.truckImplement,
      });
    }
  }, [fifthWheelEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const handleSubmit = () => {
    event.preventDefault();

    if (!formData['truckImplement']) {
      return toast.error('Selecione um veículo');
    }

    saveEntity(formData);
  };

  const saveEntity = values => {
    const entity = {
      ...fifthWheelEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const handleInputChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <RegisterLayout>
          <Box sx={{ width: { xs: '95%', sm: '70%', lg: '50%' } }} justifyContent={'center'}>
            <RegisterTitle isNew={isNew} contentKey={'fleetSenseApp.fifthWheel'} />
            <Box>
              {loading ? (
                <Box>
                  <Typography>Loading...</Typography>
                </Box>
              ) : (
                <Box margin={'0 auto'} width={'100%'}>
                  <BoxForm onSubmit={handleSubmit}>
                    <FormControlDefault variant={'outlined'}>
                      <TypographyForms>{translate('fleetSenseApp.fifthWheel.identificationCode')}</TypographyForms>
                      <TextFieldForms
                        value={formData['identificationCode']}
                        id={'fifth-wheel-identificationCode'}
                        data-cy={'identificationCode'}
                        name={'identificationCode'}
                        required={true}
                        onChange={e => handleInputChange('identificationCode', e.target.value)}
                      />
                    </FormControlDefault>

                    <FormControlDefault>
                      <SelectPaginate
                        label={translate('fleetSenseApp.fifthWheel.truckImplement')}
                        apiUrl={'api/truck-implements'}
                        onChange={value => handleInputChange('truckImplement', value)}
                        value={formData['truckImplement']}
                        valueName="licensePlate"
                        icon="sort-down"
                        isRequired={true}
                        statusFilter
                        filterStyle={true}
                        searchName="plateSearch"
                        isDisabled={!isNew}
                      />
                    </FormControlDefault>

                    {isAdmin && (
                      <FormControlDefault>
                        <SelectPaginate
                          label={translate('fleetSenseApp.fifthWheel.company')}
                          apiUrl={'api/companies'}
                          onChange={value => handleInputChange('company', value)}
                          value={formData['company']}
                          valueName="name"
                          icon="sort-down"
                          isRequired={false}
                          filterStyle={true}
                          sortQuery={'name'}
                          isDisabled={!isNew}
                        />
                      </FormControlDefault>
                    )}
                    <RegisterButton />
                  </BoxForm>
                </Box>
              )}
            </Box>
          </Box>
        </RegisterLayout>
      </ThemeProvider>
    </>
  );
};

export default FifthWheelUpdate;
